var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._b({staticClass:"mx-auto",attrs:{"dark":""}},'v-card',_vm.$attrs,false),[_c('v-card-text',{staticClass:"pt-8"},[_c('h1',{staticClass:"text-center"},[_vm._v(" Welcome to Screener ")])]),_c('v-divider'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }